import {isIos, isIos9, isIE, isEdge, isAndroid, isSafari} from '@/utils/features';

if (isIos) {
	document.documentElement.classList.add('is-ios');
}

if (isIos9) {
	document.documentElement.classList.add('is-ios9');
}

if (isAndroid) {
	document.documentElement.classList.add('is-android');
}

if (isIE) {
	document.documentElement.classList.add('is-ie');
}

if (isEdge) {
	document.documentElement.classList.add('is-edge');
}

if (isSafari) {
	document.documentElement.classList.add('is-safari');
}
